import {
  TAXIS,
  EQUIPEMENT,
  HOME,
  BADGES,
  TRIPS,
  BOOKINGS,
  BILLS,
  DRIVER_TAXIS,
  DRIVERS,
  MAP,
  STATISTICS,
  RECETTE,
  COURSES_TRIPS,
  FORFAITS
} from "Constant";

import {
  IconCar,
  IconFileInvoice,
  IconHome,
  IconIdBadge2,
  IconPigMoney,
  IconTimelineEventText,
  IconTipJarPound,
  IconTools,
  IconUsersGroup,
  IconChartBar,
  IconCash,
  IconCurrencyDollar,
} from "@tabler/icons-react";

import { shouldAllowBookings } from "utils/domain";


export const ABOUT = {
  menutitle: DRIVER_TAXIS,
  Items: [
    {
      path: "/home",
      icon: IconHome,
      type: "link",
      title: MAP,
    },
    {
      path: "/users",
      icon: IconUsersGroup,
      type: "link",
      title: DRIVERS,
    },
    {
      path: "/taxis",
      icon: IconCar,
      type: "link",
      title: TAXIS,
    },
  ],
};

const DRIVERS_AXIS_MENU = {
  menutitle: TRIPS,
  Items: [
    {
      path: "/trips",
      icon: IconTipJarPound,
      type: "link",
      title: TRIPS,
    },
    ...(shouldAllowBookings() ? [{
      path: "/bookings",
      icon: IconTimelineEventText,
      type: "link",
      title: BOOKINGS,
    }] : []),
    {
      path: "/invoices",
      icon: IconFileInvoice,
      type: "link",
      title: BILLS,
    },
    {
      path: "/forfaits",
      icon: IconCurrencyDollar,
      type: "link",
      title: FORFAITS,
    }
  ],
};

const EQUIPEMENTS_MENU = {
  menutitle: EQUIPEMENT,
  Items: [
    {
      path: "/badges",
      icon: IconIdBadge2,
      type: "link",
      title: BADGES,
    },
    {
      path: "/equipements",
      icon: IconTools,
      type: "link",
      title: EQUIPEMENT,
    },
  ],
};

const STATISTICS_MENU = {
  menutitle: STATISTICS,
  Items: [
    {
      path: "/statistics/trips",
      icon: IconChartBar,
      type: "link",
      title: COURSES_TRIPS,
    },
    {
      path: "/statistics/recette",
      icon: IconCash,
      type: "link",
      title: RECETTE,
    },
  ],
};
export const MENU_ITEMS = [DRIVERS_AXIS_MENU ,STATISTICS_MENU,ABOUT,EQUIPEMENTS_MENU,];
